export default __webpack_public_path__ + "static/media/releaseNotes.2566a792.md";